/**
 * CollectorBuffer - zakladka bufora cenowek: lista, drukowanie, czyszczenie.
 * Wyodrebniony z KolektorPage.jsx.
 */

import React from 'react';

const CollectorBuffer = ({
  priceBuffer,
  handleRemoveFromBuffer,
  handleClearBuffer,
  handlePrintBuffer,
}) => (
  <div>
    <div style={{
      backgroundColor: 'var(--card-bg)',
      borderRadius: '8px',
      padding: '1rem',
      marginBottom: '1rem',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem'
      }}>
        <h6 style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: 'var(--orange)' }}>
          Bufor cenowek ({priceBuffer.length})
        </h6>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {priceBuffer.length > 0 && (
            <>
              <button
                onClick={handlePrintBuffer}
                style={{
                  padding: '6px 12px',
                  border: '1px solid var(--success)',
                  color: 'var(--success)',
                  fontSize: '12px'
                }}
              >
                Drukuj
              </button>
              <button
                onClick={handleClearBuffer}
                style={{
                  padding: '6px 12px',
                  border: '1px solid var(--danger)',
                  color: 'var(--danger)',
                  fontSize: '12px'
                }}
              >
                Wyczysc
              </button>
            </>
          )}
        </div>
      </div>

      {priceBuffer.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '2rem',
          color: 'var(--text-muted)'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '1rem' }}>&var(--cyan);&#65039;</div>
          <div>Bufor jest pusty</div>
          <div style={{ fontSize: '12px', marginTop: '0.5rem' }}>
            Zeskanuj produkty w zakladce "Ceny" i dodaj je do bufora
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {priceBuffer.map((product, index) => (
            <div
              key={product.bufferId || product.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.75rem',
                backgroundColor: 'var(--bg)',
                borderRadius: '6px',
                borderLeft: '3px solid var(--orange)'
              }}
            >
              <div style={{
                minWidth: '24px',
                fontSize: '12px',
                fontWeight: '600',
                color: 'var(--text-muted)'
              }}>
                {index + 1}.
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', fontSize: '13px' }}>
                  {product.nazwa || product.name}
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                  {product.ean || product.kod_produktu} | {(product.cena_sprzedazy_brutto || product.cenowka?.cena_cenowkowa)?.toFixed(2)} zl
                </div>
              </div>
              <button
                onClick={() => handleRemoveFromBuffer(product)}
                style={{
                  padding: '4px 10px',
                  backgroundColor: 'var(--danger-light)',
                  color: 'var(--danger)',
                  cursor: 'pointer',
                  fontSize: '11px'
                }}
              >
                &#10005;
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
);

export default CollectorBuffer;
